import SpinnerBold from '@/assets/icons/spinner-bold.svg';
import SpinnerBolder from '@/assets/icons/spinner-bolder.svg';
import SpinnerSvg from '@/assets/icons/spinner.svg';
import { View } from "@/components/Theme/View";
import { iconSize } from '@/helper/Sizes';
import { useThemeColor } from '@/hooks/useThemeColor';
import { useEffect, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import Animated, {
    cancelAnimation,
    Easing,
    useAnimatedStyle,
    useSharedValue,
    withRepeat,
    withTiming,
} from 'react-native-reanimated';

export const Spinner = (props) => {
    const rotation = useSharedValue(0);

    const {
        color = 'bmwLightBlue.main', 
        durationMs = 1000,
        size = 'md', 
        style = {},
        bold = undefined,
        bolder = undefined,
        ...rest
    } = props;

    const _iconSize = useMemo(() => iconSize(size), [size]);

    const spinnerColor = useThemeColor(color);

    const animatedStyles = useAnimatedStyle(() => ({
        transform: [{rotateZ: `${rotation.value}deg`}],
    }), [rotation.value]);

    const SpinnerComp = bold ? SpinnerBold : bolder ? SpinnerBolder : SpinnerSvg;

    useEffect(() => {
        rotation.value = withRepeat(withTiming(360, { duration: durationMs, easing: Easing.linear}), -1);

        return () => cancelAnimation(rotation);
    }, []);

    return (
        <View style={[styles.container, style, {width: _iconSize, height: _iconSize}]} {...rest}>
            <Animated.View style={[animatedStyles]}>
                <SpinnerComp fill={spinnerColor} style={{width: _iconSize, height: _iconSize, aspectRatio: 1}} />
            </Animated.View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center'
    }
});